import { render, staticRenderFns } from "./Sjbg.vue?vue&type=template&id=76d84923&scoped=true&"
import script from "./Sjbg.vue?vue&type=script&lang=js&"
export * from "./Sjbg.vue?vue&type=script&lang=js&"
import style0 from "./Sjbg.vue?vue&type=style&index=0&id=76d84923&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d84923",
  null
  
)

export default component.exports